import React, { useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import utils from '@gjensidige/core-utilities-css';
import { CriticalButton, SecondaryButton } from '@gjensidige/nci-core-buttons';
import { Input } from '@gjensidige/nci-core-forms/lib/input';
import { Title } from '@gjensidige/nci-core-typography';

// import { runFetch } from '../service/api';
import styles from '../assets/styles/shared.module.scss';

export const ResetPassword: React.FunctionComponent = () => {
  const [email, setEmail] = useState('');
  const [emailInvalid, setEmailInvalid] = useState(false);
  // const [successMsg, setSuccessMsg] = useState('');
  // const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const handleClick = async (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    // const hostUrl = window.location.origin;
    // const body = `email=${email}&mode=forgot`;
    // const fetchResponse = await runFetch(body);
    // if (fetchResponse.success) {
    //   setLoading(false);
    //   setSuccessMsg(fetchResponse.data.success[0]);
    // } else {
    //   setLoading(false);
    //   setErrorMsg(
    //     fetchResponse.error.errors
    //       ? fetchResponse.error.errors[0]
    //       : 'Something went wrong when trying to login, please try again.'
    //   );
    // }
  };

  const checkInputs = () => {
    email === '' ? setEmailInvalid(true) : setEmailInvalid(false);
  };

  return (
    <div className={styles.overrides}>
      {/* {errorMsg && (
        <Alert alertType="error" className="mb-2">
          <Text size="p">{errorMsg}</Text>
        </Alert>
      )}
      {successMsg && (
        <Alert alertType="success" className="mb-2">
          <Text size="p">{successMsg}</Text>
        </Alert>
      )} */}
      <Title tag="h1">Reset password</Title>
      <form
        className={utils['mt-2']}
        action="#"
        onSubmit={(event) => handleClick(event)}
      >
        <Input
          id="email"
          name="email"
          labelText="Enter registered email"
          errorText="Email is required"
          invalid={emailInvalid}
          value={email}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setEmail(event.currentTarget.value)
          }
          required={true}
          className={styles.inputWidth}
        />
        <CriticalButton
          className={classNames(utils['mr-1'], utils['mt-2'])}
          type="submit"
          loading={loading}
          onClick={() => checkInputs()}
        >
          Request new password
        </CriticalButton>
      </form>
      <SecondaryButton
        className={classNames(styles.secondaryButton, utils['mt-1'])}
        onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => {
          event.preventDefault();
          history.push('/login');
        }}
      >
        Go back
      </SecondaryButton>
    </div>
  );
};
